import { actionTypes } from '../actions/auth.action'

const initialState = {
    credentials: {
        email: '',
        password: ''
    },
    next: false,
    error: {}
}

const authReducer = (state = initialState, { type, payload }) => {
    switch (type) {

    case actionTypes.CHANGE:
        return { 
            ...state,
            credentials: {
                ...state.credentials,
                ...payload
            }
        }

    case actionTypes.NEXT:
        return { 
            ...state,
            next: payload
        }

    case actionTypes.ERROR:
        return {
            ...state,
            error: payload
        }

    default:
        return state
    }
}

export default authReducer